var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrans6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 28,
    r: 27.5,
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_4774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2004 35.1094H13.0762C11.3799 35.1094 10 33.7295 10 32.0332C10 31.5085 10.1352 31.0068 10.4015 30.5402L20.6494 12.0941C21.1871 11.1128 22.2155 10.5 23.3301 10.5C24.4446 10.5 25.473 11.1128 26.0137 12.0992L35.813 29.7091C35.9683 29.9884 35.9843 30.3249 35.8571 30.6173C35.729 30.9107 35.4716 31.128 35.1612 31.2041C33.4158 31.6317 31.9077 32.8723 31.1277 34.5226C30.9574 34.8811 30.597 35.1094 30.2004 35.1094Z",
    fill: "#FFDF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2004 35.1094C30.597 35.1094 30.9574 34.8811 31.1276 34.5226C31.9077 32.8723 33.4158 31.6317 35.1611 31.2041C35.4715 31.128 35.7289 30.9107 35.8571 30.6173C35.9842 30.3249 35.9682 29.9884 35.813 29.7091L26.0137 12.0992C25.473 11.1128 24.4446 10.5 23.3301 10.5V35.1094H30.2004Z",
    fill: "#FFBE40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3301 24.8555C22.7633 24.8555 22.3047 24.3968 22.3047 23.8301V19.7285C22.3047 19.1617 22.7633 18.7031 23.3301 18.7031C23.8968 18.7031 24.3555 19.1617 24.3555 19.7285V23.8301C24.3555 24.3968 23.8968 24.8555 23.3301 24.8555Z",
    fill: "#4D4D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3301 28.957C23.8964 28.957 24.3555 28.4979 24.3555 27.9316C24.3555 27.3653 23.8964 26.9062 23.3301 26.9062C22.7638 26.9062 22.3047 27.3653 22.3047 27.9316C22.3047 28.4979 22.7638 28.957 23.3301 28.957Z",
    fill: "#4D4D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7969 45.5C41.3273 45.5 45 41.8273 45 37.2969C45 32.7664 41.3273 29.0938 36.7969 29.0938C32.2664 29.0938 28.5938 32.7664 28.5938 37.2969C28.5938 41.8273 32.2664 45.5 36.7969 45.5Z",
    fill: "#59ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 37.2969C45 32.7664 41.3274 29.0938 36.7969 29.0938V45.5C41.3274 45.5 45 41.8274 45 37.2969Z",
    fill: "#4D87FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7969 43.4492C40.1947 43.4492 42.9492 40.6947 42.9492 37.2969C42.9492 33.899 40.1947 31.1445 36.7969 31.1445C33.399 31.1445 30.6445 33.899 30.6445 37.2969C30.6445 40.6947 33.399 43.4492 36.7969 43.4492Z",
    fill: "#F3F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9492 37.2969C42.9492 33.9043 40.1895 31.1445 36.7969 31.1445V43.4492C40.1895 43.4492 42.9492 40.6895 42.9492 37.2969Z",
    fill: "#E1E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.873 38.3223H36.7969C36.2301 38.3223 35.7715 37.8636 35.7715 37.2969V34.2207C35.7715 33.6539 36.2301 33.1953 36.7969 33.1953C37.3636 33.1953 37.8223 33.6539 37.8223 34.2207V36.2715H39.873C40.4398 36.2715 40.8984 36.7301 40.8984 37.2969C40.8984 37.8636 40.4398 38.3223 39.873 38.3223Z",
    fill: "#4D4D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.873 38.3223C40.4398 38.3223 40.8984 37.8636 40.8984 37.2969C40.8984 36.7301 40.4398 36.2715 39.873 36.2715H37.8223V34.2207C37.8223 33.6539 37.3636 33.1953 36.7969 33.1953V38.3223H39.873Z",
    fill: "#443D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3555 27.9316C24.3555 27.3654 23.8964 26.9062 23.3301 26.9062V28.957C23.8964 28.957 24.3555 28.4979 24.3555 27.9316Z",
    fill: "#443D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3555 23.8301V19.7285C24.3555 19.1617 23.8968 18.7031 23.3301 18.7031V24.8555C23.8968 24.8555 24.3555 24.3968 24.3555 23.8301Z",
    fill: "#443D66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_4774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(10 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrans6);
export default __webpack_public_path__ + "static/media/trans6.5fa175c3bfcf24035a00bfe4d5aa814c.svg";
export { ForwardRef as ReactComponent };